<div class="profile-button">
  <a [matMenuTriggerFor]="matMenuPortfolio"
    ><span class="profile-button-text">
      <span *scText="rendering.fields.WelcomeMessageLabel"></span>
      {{ username }}
    </span>
    <span class="caret"></span
  ></a>
  <mat-menu
    #matMenuPortfolio="matMenu"
    yPosition="above"
    xPosition="before"
    hasBackdrop="false"
    class="portfolio-actions-list"
  >
    <ul class="list-unstyled">
      <li
        class="portfolio-header"
        *scText="rendering.fields.SwitchPortfolioLabel"
      ></li>
      <div class="loader-bar" *ngIf="isLoadingPortfolios"></div>
      <li
        class="actions-list-item"
        *ngFor="let portfolio of portfolios"
        [ngClass]="
          portfolio.isSelected
            ? 'portfolio-actions-list-item-active'
            : 'portfolio-actions-list-item'
        "
        (click)="changePortfolio(portfolio.id)"
      >
        <i *ngIf="portfolio.isSelected" class="icon-checkmark"></i>
        <span *ngIf="portfolio.isSelected">{{ portfolio.name }}</span>
        <a *ngIf="!portfolio.isSelected">{{ portfolio.name }}</a>
      </li>
      <li
        class="actions-list-item portfolio-actions-list-item portfolio-actions-list-item-logout"
        (click)="logout()"
      >
        <a *scText="rendering.fields.LogOutButton"></a>
      </li>
    </ul>
  </mat-menu>
</div>
<ab-loader [showLoader]="isLoading"></ab-loader>
